var KnowAboutData = [
  {
    id: 1,
    name: "Electrician",
    imgUrl: "electrician.png",
    jobLink: "/jobs/electrician",
    candLink: "candidates/electrician",
  },
  {
    id: 2,
    name: "Plumber",
    imgUrl: "plumber.png",
    jobLink: "/jobs/plumber",
    candLink: "candidates/plumber",
  },
  {
    id: 3,
    name: "Mechanic",
    imgUrl: "mechanic.png",
    jobLink: "/jobs/mechanic",
    candLink: "candidates/mechanic",
  },
  {
    id: 4,
    name: "Cook",
    imgUrl: "cook.png",
    jobLink: "/jobs/cooking",
    candLink: "candidates/cooking",
  },
  {
    id: 5,
    name: "Peon",
    imgUrl: "peon.png",
    jobLink: "/jobs/peon",
    candLink: "candidates/peon",
  },
  {
    id: 6,
    name: "Driver",
    imgUrl: "driver.png",
    jobLink: "/jobs/driver",
    candLink: "candidates/driver",
  },
  {
    id: 7,
    name: "House Keeping",
    imgUrl: "maid.png",
    jobLink: "/jobs/housekeeping",
    candLink: "candidates/housekeeping",
  },
  {
    id: 8,
    name: "Construction Site Workers",
    imgUrl: "site.png",
    jobLink: "/jobs/siteworkers",
    candLink: "candidates/siteworkers",
  },
  {
    id: 9,
    name: "Security Guard",
    imgUrl: "security.png",
    jobLink: "/jobs/securityguard",
    candLink: "candidates/securityguard",
  },
];

export default KnowAboutData;
